import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "Qualification_div"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "Qualification Qualification_title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "Qualification_title_h1" }, "Proceso de habilitación"),
  /*#__PURE__*/_createElementVNode("p", { class: "Qualification_title_p" }, "Conoce el proceso que debes realizar para habilitarte ante la DIAN. Te invitamos a ver el vídeo o descargar el instructivo.")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "Qualification_video"
}
const _hoisted_4 = {
  id: "video",
  class: "Qualification_video_player",
  controls: ""
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "Qualification Qualification_download" }
const _hoisted_7 = { class: "Qualification_Container_icon" }
const _hoisted_8 = { class: "Qualification Qualification_Container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", null, "Código Habilitación", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Initial = _resolveComponent("Initial")!
  const _component_Process = _resolveComponent("Process")!
  const _component_Approved = _resolveComponent("Approved")!
  const _component_Rejected = _resolveComponent("Rejected")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.spinnerView)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          type: "modern"
        }))
      : _createCommentVNode("", true),
    (!$setup.spinnerView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          ($setup.urlvd != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("video", _hoisted_4, [
                  _createElementVNode("source", {
                    src: $setup.urlvd,
                    type: "video/mp4"
                  }, null, 8, _hoisted_5)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, [
              _createTextVNode("Instructivo proceso de habilitación "),
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.Download()))
              }, [
                _createElementVNode("em", _hoisted_7, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'download'] })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            ($setup.stateHabilitacion == 'Inicial')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_Initial, { onOnFire: $setup.changeState }, null, 8, ["onOnFire"])
                ]))
              : _createCommentVNode("", true),
            ($setup.stateHabilitacion == 'EnProceso' || $setup.stateHabilitacion == 'ErrorTercero')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_Process)
                ]))
              : _createCommentVNode("", true),
            ($setup.stateHabilitacion == 'Aprobado')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_Approved)
                ]))
              : _createCommentVNode("", true),
            ($setup.stateHabilitacion == 'Rechazado')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_Rejected, { onOnFire: $setup.changeState }, null, 8, ["onOnFire"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}